/* global $ */ // eslint-disable-line no-redeclare
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import PoweredBy from '@/components/PoweredBy/PoweredByView.vue';

import { get_token, getCookie } from '@/router/index.js';

export default {
  name: 'AuditTrailView',
  components: { Sidebar, Navbar, PoweredBy },

  data: () => ({
    audits: [],
    csrf_token: '',
    pagination: {
      total: 0,
      num_pages: 0,
      current_page: 1,
      page_size: 100,
      has_next: false,
      has_previous: false,
      next_page: null,
      previous_page: null,
    },
    unique_users: [],
    unique_sources: [],
    data_table: null,
    dt_filter_fn: null,
    is_loading: false,
    table_key: 0,

    platform_cache: { all: [], orcaa: null, engagenet: null, workflows: null, proba: null },

    platform_endpoints: {
      orcaa: '/aic_one_api/system_management/get_orcaa_audits/',
      engagenet: '/aic_one_api/system_management/get_engagenet_audits/',
      workflows: '/aic_one_api/system_management/get_workflow_audits/',
      proba: '/aic_one_api/system_management/get_proba_audits/',
    },

    platforms_static: [
      { key: 'all', label: 'AIC One (All)' },
      { key: 'orcaa', label: 'Orcaa' },
      { key: 'engagenet', label: 'EngageNet' },
      { key: 'workflows', label: 'Workflows' },
      { key: 'proba', label: 'Proba Analytics' },
    ],

    safe_platform_keys: new Set(['all', 'orcaa', 'engagenet', 'workflows', 'proba']),
    current_platform_key: 'all',
  }),

  computed: {
    platform_label_map() {
      return this.platforms_static;
    },
  },

  mounted() {
    this.csrf_token = getCookie('csrftoken');
    this.force_platform_labels();
    this.fetch_audits();
  },

  watch: {
    audits(new_val) {
      this.unique_users = [...new Set(new_val.map((u) => u.user_full_names).filter(Boolean))];
    },
  },

  methods: {

    safe_get_endpoint(platform_key) {
      if (!(typeof platform_key === 'string' && this.safe_platform_keys.has(platform_key))) return null;
      const descriptor = Object.getOwnPropertyDescriptor(this.platform_endpoints, platform_key);
      if (!descriptor || !descriptor.enumerable || typeof descriptor.value !== 'string') return null;
      return descriptor.value;
    },

    safe_read_cache(platform_key) {
      if (!(typeof platform_key === 'string' && this.safe_platform_keys.has(platform_key))) return null;
      const descriptor = Object.getOwnPropertyDescriptor(this.platform_cache, platform_key);
      if (!descriptor || !descriptor.enumerable) return null;
      const value = descriptor.value;
      return Array.isArray(value) ? [...value] : null;
    },

    safe_write_cache(platform_key, data_rows) {
      if (!(typeof platform_key === 'string' && this.safe_platform_keys.has(platform_key))) return;
      Object.defineProperty(this.platform_cache, platform_key, {
        value: Array.isArray(data_rows) ? [...data_rows] : [],
        writable: true,
        enumerable: true,
        configurable: true,
      });
    },

    force_platform_labels() {
      this.unique_sources = this.platforms_static.map((p) => p.label);
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const el = document.getElementById('audit_trail_table');
        if (!el || !$.fn?.DataTable) return;

        const table_el = $('#audit_trail_table');

        if ($.fn.DataTable.isDataTable(table_el)) {
          table_el.DataTable().clear().destroy();
          table_el.find('thead,tbody').removeAttr('style');
        }

        if (this.dt_filter_fn) {
          $.fn.dataTable.ext.search = $.fn.dataTable.ext.search.filter((fn) => fn !== this.dt_filter_fn);
          this.dt_filter_fn = null;
        }

        this.dt_filter_fn = (_settings, row_data) => this.filter_data(_settings, row_data);
        $.fn.dataTable.ext.search.push(this.dt_filter_fn);

        this.data_table = table_el.DataTable({
          pageLength: 10,
          lengthChange: false,
          searching: true,
          ordering: true,
          paging: true,
          info: true,
          autoWidth: false,
          dom: 'ltip',
        });

        // Apply + input handlers
        $('.filter-button').off('click').on('click', () => {
          if (this.data_table) this.data_table.draw();
        });

        $('#apply_filters').off('click').on('click', () => {
          if (this.data_table) this.data_table.draw();
          const btn = document.querySelector('.filter-button.dropdown-toggle');
          const bs = window.bootstrap;
          if (btn && bs && bs.Dropdown) bs.Dropdown.getOrCreateInstance(btn).hide();
        });

        $('.filter-input').off('change input').on('change input', () => {
          if (this.data_table) this.data_table.draw();
        });

        $('#source_filter').off('change').on('change', async (e) => {
          const selected_label = (e && e.target && e.target.value) || '';

          if (!selected_label) {
            this.current_platform_key = 'all';
            await this.use_unfiltered_dataset();
            if (this.data_table) this.data_table.draw();
            return;
          }

          const rec = this.platform_label_map.find((p) => p.label === selected_label) || null;
          const platform_key = rec?.key || 'all';

          this.current_platform_key = platform_key;
          await this.handle_platform_filter(selected_label);
          if (this.data_table) this.data_table.draw();
        });

        // Reset filters
        $('#reset_filters').off('click').on('click', async () => {
          $('#user_filter').val('');
          $('#source_filter').val('');
          $('#risk_level_filter').val('');
          $('#date_from').val('');
          $('#date_to').val('');

          this.current_platform_key = 'all';
          this.force_platform_labels();
          await this.use_unfiltered_dataset();
          if (this.data_table) this.data_table.draw();
        });
      });
    },

    rebuild_table() {
      const $old = $('#audit_trail_table');
      if ($old.length && $.fn.DataTable && $.fn.DataTable.isDataTable($old)) {
        $old.DataTable().clear().destroy();
        $old.find('thead,tbody').removeAttr('style');
      }

      this.table_key += 1;

      this.$nextTick(() => {
        if (document.getElementById('audit_trail_table')) {
          this.initialize_data_table();
        }
      });
    },

    // ---------- Filtering ----------
    filter_by_date(date_text, date_from_text, date_to_text) {
      const row_date = new Date(date_text);
      const from_date = date_from_text ? new Date(date_from_text) : null;
      const to_date = date_to_text ? new Date(date_to_text) : null;

      if (Number.isNaN(row_date.getTime())) return true;
      if (from_date && to_date) return row_date >= from_date && row_date <= to_date;
      if (from_date) return row_date >= from_date;
      if (to_date) return row_date <= to_date;
      return true;
    },

    filter_data(_settings, row_data) {
      const date_from_text = $('#date_from').val();
      const date_to_text = $('#date_to').val();
      const user_filter_val = $('#user_filter').val();
      const risk_level_filter_val = $('#risk_level_filter').val();

      const date_cell = row_data[4];
      const user_cell = row_data[1];
      const risk_level_cell = row_data[6];

      return (
        this.filter_by_date(date_cell, date_from_text, date_to_text) &&
        (!user_filter_val || user_cell === user_filter_val) &&
        (!risk_level_filter_val || risk_level_cell === risk_level_filter_val)
      );
    },

    // ---------- Data fetch ----------
    async handle_platform_filter(selected_label) {
      if (!selected_label) {
        await this.use_unfiltered_dataset();
        return;
      }

      const rec = this.platform_label_map.find((p) => p.label === selected_label) || null;
      const platform_key = rec ? rec.key : 'all';

      if (!this.safe_platform_keys.has(platform_key) || (platform_key !== 'all' && !(platform_key in this.platform_endpoints))) {
        await this.use_unfiltered_dataset();
        return;
      }

      if (platform_key === 'all') {
        await this.use_unfiltered_dataset();
        return;
      }

      const cached_rows = this.safe_read_cache(platform_key);
      if (cached_rows) {
        this.audits = cached_rows;
        this.rebuild_table();
        return;
      }

      const fetched_rows = await this.fetch_platform_audits(platform_key);
      this.safe_write_cache(platform_key, fetched_rows);
      this.audits = this.safe_read_cache(platform_key) || [];
      this.rebuild_table();
    },

    async use_unfiltered_dataset() {
      const base_rows = this.safe_read_cache('all');
      if (!base_rows || base_rows.length === 0) {
        await this.fetch_audits();
      } else {
        this.audits = base_rows;
        this.rebuild_table();
      }
    },

    async fetch_platform_audits(platform_key) {
      const endpoint = this.safe_get_endpoint(platform_key);
      if (!endpoint) return [];
      this.is_loading = true;
      try {
        const token = get_token();
        const url = `${process.env.VUE_APP_API_BASE_URL}${endpoint}`;
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
            'X-CSRFToken': this.csrf_token,
          },
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || json.status === 'error') {
          const error_msg = json.message || `Failed to fetch platform audits: HTTP ${res.status}`;
          this.$notyf.error(error_msg);
          return [];
        }

        // if everything is fine
        return json.data || [];

      } catch (_e) {
        this.$notyf?.info('Network error while fetching platform audits');
        return [];
      }finally {
        this.is_loading = false;
      }
    },

    async fetch_audits(page=null) {
      const token = get_token();
      if (page) {
        this.pagination.current_page = page;
      }
      const params = new URLSearchParams({
        page: this.pagination.current_page,
        page_size: this.pagination.page_size,
      });
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_unfiltered_audits/?${params.toString()}`;
      this.is_loading = true;
      try {
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
            'X-CSRFToken': this.csrf_token,
          },
        });
        const json = await res.json().catch(() => ({}));

        if (!res.ok || json.status !== 'success') {
          this.$notyf?.error(json.message || `Failed to fetch audits: HTTP ${res.status}`);
          return;
        }

        const rows = json.data || [];

        this.audits = rows;

        if (json.pagination) {
          this.pagination = {
            total: json.pagination.total,
            num_pages: json.pagination.num_pages,
            current_page: json.pagination.current_page,
            page_size: json.pagination.page_size,
            has_next: json.pagination.has_next,
            has_previous: json.pagination.has_previous,
            next_page: json.pagination.next_page,
            previous_page: json.pagination.previous_page,
          };
        }
        this.safe_write_cache(`page_${this.pagination.current_page}`, rows);
        this.rebuild_table();
      } catch (_err) {
        this.$notyf?.info('Network error while fetching audits');
      } finally {
        this.is_loading = false;
      }
    },

    go_to_page(row_or_url) {
      const url =
        typeof row_or_url === 'string'
          ? row_or_url
          : (row_or_url && row_or_url.page_url) || '';

      const desc = (
        (typeof row_or_url === 'object' && row_or_url && row_or_url.description) ||
        ''
      ).toLowerCase();

      if (!url) {
        this.$notyf?.info?.('No page URL available');
        return;
      }

      let pathname = '';
      try {
        pathname = new URL(url, window.location.origin).pathname || '';
      } catch (_e) {
        pathname = url;
      }

      const is_auth =
        pathname === '/' || /\/logout\b/i.test(pathname) ||
        /(^|[^a-z])(login|logout)([^a-z]|$)/i.test(desc);

      if (is_auth) {
        this.$notyf?.info?.('Note: Login event - nothing to open.');
        return;
      }

      window.location.assign(url);
    },

    change_page(page) {
      if (page && page >= 1 && page <= this.pagination.num_pages) {
        this.fetch_audits(page);
      }
    },

    next_page() {
      if (this.pagination.has_next && this.pagination.next_page) {
        this.fetch_audits(this.pagination.next_page);
      }
    },

    previous_page() {
      if (this.pagination.has_previous && this.pagination.previous_page) {
        this.fetch_audits(this.pagination.previous_page);
      }
    },
  },
};